import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { LocalizeRouterSettings } from '@gilsdav/ngx-translate-router';
import { LocalizeRouterHttpLoader } from '@gilsdav/ngx-translate-router-http-loader';
import { LOCALE_ID } from '@angular/core';

export const DOOD_DEFAULT_LOCALE = 'fr';
export const DOOD_DEFAULT_LOCALE_PROVIDER = { provide: LOCALE_ID, useValue: DOOD_DEFAULT_LOCALE };

export const AppLocalizeHttpLoaderFactory = (
  translate: TranslateService,
  location: Location,
  settings: LocalizeRouterSettings,
  http: HttpClient,
): LocalizeRouterHttpLoader => {
  return new LocalizeRouterHttpLoader(
    translate,
    location,
    { ...settings, alwaysSetPrefix: true },
    http,
  );
};
